<!-- src/pages/billWarning/components/FollowDialog.vue -->
<template>
  <el-dialog
    title="跟进记录"
    :visible.sync="visible"
    width="600px"
    append-to-body
  >
    <div class="follow-history">
      <template v-if="list.length">
        <div v-for="(item, i) in list" :key="i" class="follow-item">
          <div class="follow-item__head">
            <span class="follow-item__date">{{ item.gmtCreate || '--' }}</span>
            <span class="follow-item__user">{{ item.createUser || '--' }}</span>
          </div>
          <div class="follow-item__desc">{{ item.followDesc || '--' }}</div>
        </div>
      </template>
      <div v-else class="follow-empty">暂无跟进记录</div>
    </div>
    <el-input
      v-model="content"
      class="follow-input"
      type="textarea"
      :rows="4"
      maxlength="500"
      show-word-limit
      placeholder="输入跟进结果..."
      :class="{ 'is-error': showError }"
      @input="showError = false"
    />
    <p v-if="showError" class="follow-error">请输入跟进结果</p>
    <div slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" :loading="saving" @click="onSave"
        >保存跟进</el-button
      >
    </div>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { useFollowDialog } from '../composables/useFollowDialog'

const { visible, list, content, saving, open, save, close } = useFollowDialog()
const showError = ref(false)

async function onSave() {
  if (!content.value.trim()) {
    showError.value = true
    return
  }
  showError.value = false
  await save()
}

async function onOpen(overdueId) {
  showError.value = false
  await open(overdueId)
}

defineExpose({ open: onOpen })
</script>

<style scoped lang="scss">
.follow-history {
  max-height: 320px;
  overflow-y: auto;
  margin-bottom: 16px;
}

.follow-item {
  background: #f7f8fa;
  border: 1px solid #ebedf0;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 8px;
}

.follow-item__head {
  display: flex;
  justify-content: space-between;
}

.follow-item__date {
  color: #969799;
  font-size: 12px;
}

.follow-item__user {
  color: #2e7eff;
  font-size: 12px;
}

.follow-item__desc {
  color: #323233;
  margin-top: 4px;
}

.follow-empty {
  color: #969799;
  text-align: center;
  padding: 24px 0;
}

.follow-input.is-error ::v-deep .el-textarea__inner {
  border-color: #f56c6c;
}

.follow-error {
  color: #f56c6c;
  font-size: 12px;
  margin: 4px 0 0;
}
</style>
